// The three tabs of a match, named once so the type derives from the values and the search
// param cannot hold a fourth.

export const MATCH_TABS = ['highlights', 'scoreLines', 'measures'] as const

export type MatchTab = (typeof MATCH_TABS)[number]
